  export enum UsageType {
  base = 0,
  openClose = 1,
  lateUtilityFundingAdjustment = 2,
  lateFunding = 3
}
